<template>
  <div>
    <FullCalendar ref="fullCalendar" :options="calendarOptions"/>
    <cal-hover ref="calHover" :users="users" :renforts="renforts" :participantsCount="participantsCount" :userType="type"></cal-hover>
  </div>
</template>

<script>
import frLocale from "@fullcalendar/core/locales/fr";
import "@fullcalendar/core/vdom"
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import timeGridPlugin from "@fullcalendar/timegrid";
import FullCalendar from "@fullcalendar/vue";

export default {
  components: {
    FullCalendar,
  },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    renforts: {
      type: Array,
      default: () => [],
    },
    type:{
      type: Object,
      default: () => []
    },
  },
  data: function () {
    return {
      calendarOptions: this.getCalendarOptions(),
      selectedEvent:{
        eventTitle: '',
        eventStart: '',
        eventEnd: '',
        eventId: 0,
        color: '#1FBC9C',
        userId: '',
        renfortId: '',
        usersIds:[],
        renfortsIds:[],
        meeting_point:''
      }
    };
  },
  methods: {
    getCalendarOptions(){
      let commonConfig = {
        displayEventTime : false,
        dayMaxEvents: true,
        locale: frLocale,
        events: {
          url: "calendar/event",
          type: "GET",
          success: (content, xhr) => this.handleEvents(content, xhr)
        },
        datesSet: this.datesSet,
        select: (selectionInfo)=>this.$emit('select', selectionInfo),
        eventClick: (clickInfo)=>this.$emit('event-click', clickInfo),
        eventMouseEnter:(info)=>this.$refs.calHover.hover(info.event),
        eventMouseLeave:()=>this.$snotify.clear(),
        eventDrop:this.eventMove,
        eventResize:this.eventMove
      };

      let isSmallScreen = window.matchMedia("(max-width: 767px)").matches
      let configStruct = {
        schedulerLicenseKey: process.env.MIX_FULL_CALENDAR_LICENSE_KEY,
        plugins: isSmallScreen?[interactionPlugin,resourceTimelinePlugin]:[interactionPlugin, dayGridPlugin,resourceTimelinePlugin],
        editable: true,
        selectable: true,
        headerToolbar: {
          left: isSmallScreen?"prev,next":"prev,next today",
          center: "title",
          right: isSmallScreen?"today":"dayGridMonth,resourceTimelineWeek,resourceTimeline",
        },
        initialView: "resourceTimeline",
        buttonText:{
          resourceTimelineWeek:"Semaine",
          resourceTimeline:"Jour"
        },
        views: {
          resourceTimeline: {
            titleFormat: { weekday: "short", day: "numeric", month: "short", year: "numeric"},
            nowIndicator: true,
          },
        },
        resourceAreaHeaderContent : 'Encadrants',
        resourceAreaWidth: '10%',
        resourceGroupField: 'type',
        resourceGroupLabelContent: (group) =>group.groupValue == "user" ? "Permanent(s)" : "Renfort(s)",
        resourceOrder: '-prior,fullName',
        resources: this.getAllResources()
      }

      let configBureau = {
        headerToolbar: {
          left: isSmallScreen?"prev,next":"prev,next today",
          center: "title",
          right: isSmallScreen?"today":"dayGridMonth,next21Days,resourceTimelineWeekSlot",
        },
        buttonText:{
          next21Days:"21 jours",
          resourceTimeline:"Jour"
        },
        initialView: isSmallScreen?'resourceTimeline':'next21Days',
        views: {
          next21Days: {
            type: 'resourceTimelineWeek',
            duration: {days: 21},
            slotLabelFormat:{weekday: 'short', day: 'numeric'}
          },
          resourceTimelineWeekSlot: {
            type: 'resourceTimelineWeek',
            slotMinTime: '07:00',
            slotMaxTime: '19:00',
            slotDuration: '06:00',
            slotLabelFormat:{weekday: 'short', day: 'numeric'},
            slotLabelInterval:'12:00'//only show 1st level slotlabel
          },
        }
      }

      let configSolo = {
        plugins: isSmallScreen?[listPlugin]:[interactionPlugin, dayGridPlugin, timeGridPlugin],
        editable: true,
        selectable: true,
        headerToolbar: {
          left: isSmallScreen?'prev,next':'prev,next today',
          center: 'title',
          right: isSmallScreen?'listWeek,listDay,listMonth':'dayGridMonth,timeGridWeek,timeGridDay'
        },
        initialView: isSmallScreen?'listWeek':'dayGridMonth',
        views: {
          timeGridDay: {
            titleFormat:{ weekday: "short", day: "numeric", month: "short", year: "numeric"},
            nowIndicator: true
          },
          listDay: { buttonText: 'Jour' },
          listWeek: { buttonText: 'Semaine' },
          listMonth: { buttonText: 'Mois' }
        },
        slotEventOverlap:false,
        height:"auto"
      };

      let configAmbassador = {
        plugins: [dayGridPlugin],
        editable: false,
        selectable: false,
        slotMinTime: "07:00",
        slotMaxTime: "21:00",

        businessHours: {
          startTime: '07:00',
          endTime:   '21:00'
        },
        headerToolbar: {
          left: 'prev,next,today',
          center: 'title',
          right: ''
        },
        initialView: "dayGridMonth",
      }

      let configDefaultHours = {
        slotMinTime: "08:00",
        slotMaxTime: "21:00",

        businessHours: {
          startTime: '8:00',
          endTime:   '19:00'
        }
      }

      //render config depending on user type
      if(this.type.role=="ambassador"){
        return Object.assign({}, commonConfig, configAmbassador);
      }
      switch(this.type.type){
        case 'solo':
          return Object.assign({}, commonConfig, configSolo, configDefaultHours);
        case 'bureau':
          return Object.assign({}, commonConfig, configStruct, configBureau);
        default://type structure other than bureau
          return Object.assign({}, commonConfig, configStruct, configDefaultHours);
      }
    },
    handleEvents(content, xhr) {
      let canHandleBackground = !(this.getApi().view.type == "listWeek" || this.getApi().view.type == "listDay" || this.getApi().view.type == "dayGridMonth")
      return Object.values(content.data).map((event) => {
        //for booking display customer name + event title as title
        let eventTitle =event.booking != null? event.booking.customer.fullName + " " + event.title: event.title;
        let eventShortTitle = eventTitle; //save title without participant
        let eventBookingMultiple = {};
        if (event.bookingMultiple && Object.keys(event.bookingMultiple).length != 0) {
          eventTitle +=" - " + this.participantsCount(event.bookingMultiple.groups) +"/" +event.bookingMultiple.total_places;
          eventBookingMultiple = event.bookingMultiple;
        }
        let paymentIco = "";
        if (event.booking && Object.keys(event.booking).length != 0 && event.booking.booking_invitations.length > 0) {
          paymentIco = event.booking.booking_invitations[0].order ? "€ " : "✉ ";
        }
        let formatedEvent = {
          id: event.id,
          title: paymentIco + eventTitle,
          shortTitle: eventShortTitle,
          start: event.start,
          end: event.end,
          backgroundColor: event.color,
          borderColor: event.color,
          userId: event.user_id,
          renfortId: event.renfort_id,
          usersIds: event.users_ids,
          renfortsIds: event.renforts_ids,
          activity: event.activity != null ? event.activity : {},
          booking: event.booking != null ? event.booking : {},
          bookingMultiple: eventBookingMultiple,
          meeting_point: event.meeting_point,
          display: event.display,
          officeName: event.officeName,
        };
        if(event.display == "background"){//other struct event
          formatedEvent.classNames = [`other-office`]
          formatedEvent.editable=false;
          formatedEvent.title = 'Indispo'
          if(this.type.type == "solo" && event.officeName){
            formatedEvent.title += ' ('+event.officeName+')'
            if(!canHandleBackground){//display on month view if solo
              formatedEvent.display = "auto"
            }
          }
        }

        let resourceIds = this.getResourceId(event);
        if (Array.isArray(resourceIds)) {//BookingMultiple encadrants
          formatedEvent.resourceIds = resourceIds;
        } else {
          formatedEvent.resourceId = resourceIds;
        }
        return formatedEvent;
      });
    },
    datesSet(info){
      let canHandleBackground = !(info.view.type == "listWeek" || info.view.type == "listDay" || info.view.type == "dayGridMonth")
      let events = this.getApi().getEvents();
      events.map((event)=>{//change display background to auto to show all events on month view
        if(this.type.type == "solo"){
          if(event.display == "background" && !canHandleBackground){
            event.setProp('display','auto')
          }else if(event.classNames.includes(`other-office`) && canHandleBackground){
            event.setProp('display','background')
          }
        }
      })
    },
    eventMove(moveInfo){
      let deltaChange = (delta)=>delta && (delta.years != 0 || delta.months != 0 || delta.days != 0 || delta.milliseconds != 0);//check if event has moved
      let evt = {}
      if(moveInfo.newResource){//enc change
        evt.old_enc={id:moveInfo.oldResource.extendedProps.resourceId,type:moveInfo.oldResource.extendedProps.type}
        evt.new_enc={id:moveInfo.newResource.extendedProps.resourceId,type:moveInfo.newResource.extendedProps.type}
      }
      if(deltaChange(moveInfo.delta) || deltaChange(moveInfo.startDelta) || deltaChange(moveInfo.endDelta)){//date change
        evt.start = moment(moveInfo.event.start).format('YYYY-MM-DD HH:mm:ss')
        evt.end = moment(moveInfo.event.end).format('YYYY-MM-DD HH:mm:ss')
      }
      axios.put('calendar/event/' + moveInfo.event.id + '/drop', evt )
        .then(response => {
          this.$snotify.success('Evénement mis à jour')
        })
        .finally(()=>{
          this.getApi().refetchEvents()
        });
    },
    participantsCount(groups) {
      return groups.reduce(function (acc, current) {
        let count = current != null ? parseInt(current.group_count) : 0;
        return acc + count;
      }, 0);
    },
    getAllResources() {
      //merge users and renforts and return merged data as resources
      return this.users.concat(this.renforts).map(function (enc) {
        let prior = enc.email_hash? +enc.pivot.priority + 1: +enc.priority + 1;
        return {
          id: enc.email_hash ? enc.id + "_U" : enc.id + "_R",
          resourceId: enc.id,
          title: prior + "★ " + enc.fullName,
          prior:prior,
          fullName:enc.fullName,
          type: enc.email_hash ? "user" : "renfort",
        };
      });
    },
    getResourceId(data) {
      if (!data.bookingMultiple || Object.keys(data.bookingMultiple).length == 0) {//not bookingMultiple
        return data.user_id ? data.user_id + "_U" : data.renfort_id + "_R";
      }
      if (data.users_ids.length + data.renforts_ids.length == 0) {//no enc
        return data.user_id + "_U"; //display on author row
      }
      let ids = [];
      for (let id of data.users_ids) {
        ids.push(id + "_U");
      }
      for (let id of data.renforts_ids) {
        ids.push(id + "_R");
      }
      return ids;
    },
    getApi(){
      return this.$refs.fullCalendar.getApi()
    },
  },
};
</script>
